import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

export const useApplySearchKeywordFilter = ({
  query,
  searchedKeyword,
  nextPath,
}: {
  query: URLSearchParams;
  searchedKeyword: string;
  nextPath: string;
}) => {
  const history = useHistory();
  const [isSearchInputTouched, setIsSearchInputTouched] = useState(false);

  useEffect(() => {
    if (searchedKeyword) {
      setIsSearchInputTouched(true);
      query.set("s", searchedKeyword);
      history.push({
        pathname: nextPath,
        search: query.toString(),
      });
    } else if (isSearchInputTouched) {
      history.push({
        pathname: nextPath,
        search: "",
      });
    }
  }, [query, searchedKeyword, nextPath, history, isSearchInputTouched]);
};
